$("body").on('formajax:success', "#feedback_form", function (e) {
  var xhr = e.detail.xhr,
  responseJSON = JSON.parse(xhr.responseText);

    if (responseJSON.error) {
      app.dialog.alert(responseJSON.errorText, "Ошибка");
  }

    if (responseJSON.success) {
      app.dialog.alert(responseJSON.message, "Успешно");
      Events.notify('feedback-sended');
      Popup.close();

        }
});


